import React from 'react';
import { Thermometer, Wrench, Building, ClipboardCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: Thermometer,
  title: 'Installation',
  description: 'Daikin/Mitsubishi specialists, bespoke from £100+VAT'
}, {
  icon: Wrench,
  title: 'Maintenance',
  description: '6/12-month contracts with photo reports'
}, {
  icon: Building,
  title: 'FM & Ad-Hoc Support',
  description: 'White-label, in-house support'
}, {
  icon: ClipboardCheck,
  title: 'TM44 Compliance',
  description: '5yr compliance, >12kW, ISO14001-linked'
}];
const highlights = [{
  icon: 'https://cdn.magicpatterns.com/uploads/9RHSsu48RcfwNCQa8fX12h/icon-daikin.svg',
  title: 'Daikin D1+ Partner',
  description: 'Certified premium partner for Daikin air conditioning systems.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#E8F0F8]" data-id="element-220">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-221">
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-16" data-id="element-222">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-6" data-id="element-223">
              <div className="flex-shrink-0" data-id="element-224">
                <service.icon className="w-8 h-8 text-accent stroke-[1.5]" data-id="element-225" />
              </div>
              <div data-id="element-226">
                <h3 className="text-2xl mb-4" data-id="element-227">{service.title}</h3>
                <p className="text-primary-dark/70 leading-relaxed text-sm" data-id="element-228">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}